import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { BreakpointObserver } from '@angular/cdk/layout';
import { MatSidenav } from '@angular/material/sidenav';
import { NavigationEnd, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { AuthService } from 'src/app/services/auth.service';
import { OperationsArea, OperationsGroup, OperationsLink, operationsHome, operationsNavigation, operationsParent } from './operations-navigation';

@Component({
  selector: 'app-operations-shell',
  templateUrl: './operations-shell.component.html',
  styleUrls: ['./operations-shell.component.scss'],
})
export class OperationsShellComponent implements OnInit, OnDestroy {
  @Input() area: OperationsArea = 'admin';
  @Input() bare = false;
  @ViewChild('navigation') navigation!: MatSidenav;
  desktop = false;
  private destroyed$ = new Subject<void>();

  constructor(public authService: AuthService, public router: Router, private breakpoints: BreakpointObserver) {}

  get groups() { return operationsNavigation(this.area, this.authService.getUser()); }
  get home() { return operationsHome(this.area, this.authService.getUser()); }
  get parent() { return operationsParent(this.router.url); }
  get label() { return this.area === 'workers' ? 'Equipo del evento' : this.authService.getUser().isStaff ? 'Plataforma' : 'Panel del negocio'; }

  ngOnInit(): void {
    this.breakpoints.observe('(min-width: 992px)').pipe(takeUntil(this.destroyed$)).subscribe(state => {
      this.desktop = state.matches;
    });
    this.router.events.pipe(filter(event => event instanceof NavigationEnd), takeUntil(this.destroyed$)).subscribe(() => {
      this.closeMobile();
      window.scrollTo({ top: 0, behavior: 'auto' });
    });
  }

  closeMobile(): void { if (!this.desktop) this.navigation?.close(); }
  trackGroup(_index: number, group: OperationsGroup): string { return group.label; }
  trackLink(_index: number, link: OperationsLink): string { return link.path; }
  logout(): void { this.closeMobile(); this.authService.logout(); }
  ngOnDestroy(): void { this.destroyed$.next(); this.destroyed$.complete(); }
}
